import React from 'react';
import { ToolType } from '../types';

interface ToolbarProps {
  activeTool: ToolType;
  onToolChange: (tool: ToolType) => void;
  generated: boolean;
  middleWallDir?: 'horizontal' | 'vertical';
  onMiddleWallDirChange?: (dir: 'horizontal' | 'vertical') => void;
}

const tools: { type: ToolType; label: string; icon: string; desc: string }[] = [
  { type: 'select',     label: '선택',   icon: '↖',  desc: '객체 선택/이동' },
  { type: 'door',       label: '문',     icon: '🚪', desc: '벽면에 문 추가' },
  { type: 'drain',      label: '배수구', icon: '◎',  desc: '바닥에 배수구 추가' },
  { type: 'hari',       label: '하리',   icon: '▣',  desc: '기둥(하리) 추가' },
  { type: 'middleWall', label: '칸막이', icon: '┃',  desc: '칸막이(중벽) 추가' },
  { type: 'existing',   label: '기존벽', icon: '▨',  desc: '기존 벽(패널 없음) 지정/해제 — 변을 클릭' },
  { type: 'delete',     label: '삭제',   icon: '✕',  desc: '객체 삭제' },
];

const Toolbar: React.FC<ToolbarProps> = ({
  activeTool, onToolChange, generated,
  middleWallDir = 'vertical', onMiddleWallDirChange,
}) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, maxWidth: '100%', overflowX: 'auto' }}>
      <div className="pd-tools">
        {tools.map(tool => (
          <button key={tool.type} className={`pd-tool${activeTool === tool.type ? ' on' : ''}`}
            onClick={() => onToolChange(tool.type)} disabled={!generated} title={tool.desc}>
            <span className="i">{tool.icon}</span>
            <span className="t">{tool.label}</span>
          </button>
        ))}
      </div>

      {/* 칸막이 방향 */}
      {activeTool === 'middleWall' && generated && (
        <div className="pd-tools" style={{ alignItems: 'center', padding: '5px 8px', gap: 6 }}>
          <span style={{ fontSize: 13, color: 'var(--pd-mute)', marginRight: 2 }}>방향</span>
          <button className={`pd-chip${middleWallDir === 'vertical' ? ' on' : ''}`} onClick={() => onMiddleWallDirChange?.('vertical')}>┃ 세로</button>
          <button className={`pd-chip${middleWallDir === 'horizontal' ? ' on' : ''}`} onClick={() => onMiddleWallDirChange?.('horizontal')}>━ 가로</button>
        </div>
      )}
    </div>
  );
};

export default Toolbar;
